import LBox from "@components/LBox";
import { DEFAULT_BACKGROUND_STOPS } from "@components/Accesses/AccessDetails/config";
import { getViewPort } from "@utils/web/config";
import React from "react";
import { Platform, useWindowDimensions } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Svg, { Defs, LinearGradient, Rect, Stop } from "react-native-svg";

type BackgroundProps = {
  imageUrl: string | null;
};

const GRADIENT_ID = "access-bg-gradient";

const Background = ({ imageUrl }: BackgroundProps) => {
  const { width, height } = useWindowDimensions();
  const insets = useSafeAreaInsets();
  const { width: screenWidth, height: screenHeight } = getViewPort({
    width,
    height,
  });

  const backgroundHeight =
    Platform.OS === "android" ? screenHeight + insets.bottom : screenHeight;

  // NOTE: palette-from-image was previously planned; keep `imageUrl` for compatibility.
  void imageUrl;

  return (
    <LBox
      position="absolute"
      top={0}
      left={0}
      width={screenWidth}
      height={backgroundHeight}
      overflow="hidden"
    >
      <Svg width={screenWidth} height={backgroundHeight}>
        <Defs>
          <LinearGradient id={GRADIENT_ID} x1="0" y1="0" x2="0" y2="1">
            {DEFAULT_BACKGROUND_STOPS.map((stop) => (
              <Stop
                key={stop.offset}
                offset={stop.offset}
                stopColor={stop.color}
              />
            ))}
          </LinearGradient>
        </Defs>
        <Rect
          x={0}
          y={0}
          width={screenWidth}
          height={backgroundHeight}
          fill={`url(#${GRADIENT_ID})`}
        />
      </Svg>
    </LBox>
  );
};

export default Background;
